import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Table, Form, Modal, Alert, Badge } from 'react-bootstrap';
import api from '../api';


function Clients({ user }) {
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    companyInfo: '',
    contactPerson: '',
    phone: '',
    email: '',
    address: '',
    username: '',
    password: '',
    maxDevices: 10
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchClients();
  }, []);


  const fetchClients = async () => {
    try {
      const response = await api.get('/api/clients');
      setClients(response.data.data);
    } catch (err) {
      setError('Σφάλμα κατά τη φόρτωση clients');
      console.error(err);
    }
  };


  const handleShowModal = (client = null) => {
    if (client) {
      setEditingClient(client);
      setFormData({
        name: client.name,
        companyInfo: client.companyInfo || '',
        contactPerson: client.contactPerson || '',
        phone: client.phone || '',
        email: client.email || '',
        address: client.address || '',
        username: '',
        password: '',
        maxDevices: client.maxDevices || 10
      });
    } else {
      setEditingClient(null);
      setFormData({
        name: '',
        companyInfo: '',
        contactPerson: '',
        phone: '',
        email: '',
        address: '',
        username: '',
        password: '',
        maxDevices: 10
      });
    }
    setShowModal(true);
    setError('');
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setEditingClient(null);
    setError('');
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');


    try {
      if (editingClient) {
        await api.put(`/api/clients/${editingClient.id}`, {
          name: formData.name,
          companyInfo: formData.companyInfo,
          contactPerson: formData.contactPerson,
          phone: formData.phone,
          email: formData.email,
          address: formData.address,
          maxDevices: formData.maxDevices
        });
        setSuccess('Ο client ενημερώθηκε επιτυχώς');
      } else {
        await api.post('/api/clients', formData);
        setSuccess('Ο client δημιουργήθηκε επιτυχώς');
      }
      handleCloseModal();
      fetchClients();
    } catch (err) {
      setError(err.response?.data?.error || 'Σφάλμα κατά την αποθήκευση');
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον client; Θα διαγραφούν και όλα τα σχετικά δεδομένα.')) {
      return;
    }


    try {
      await api.delete(`/api/clients/${id}`);
      setSuccess('Ο client διαγράφηκε επιτυχώς');
      fetchClients();
    } catch (err) {
      setError('Σφάλμα κατά τη διαγραφή');
    }
  };


  return (
    <Container fluid>
      <Row className="mb-4">
        <Col>
          <h2><i className="bi bi-building me-2"></i>Διαχείριση Clients</h2>
        </Col>
        <Col className="text-end">
          <Button variant="primary" onClick={() => handleShowModal()}>
            <i className="bi bi-plus-circle me-1"></i>
            Νέος Client
          </Button>
        </Col>
      </Row>


      {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
      {success && <Alert variant="success" dismissible onClose={() => setSuccess('')}>{success}</Alert>}


      <Card>
        <Card.Body>
          <Table responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Όνομα</th>
                <th>Στοιχεία Επαφής</th>
                <th>Email</th>
                <th>Τηλέφωνο</th>
                <th>Τοποθεσίες</th>
                <th>Users</th>
                <th>Κατάσταση</th>
                <th>Ενέργειες</th>
              </tr>
            </thead>
            <tbody>
              {clients.map(client => (
                <tr key={client.id}>
                  <td>{client.id}</td>
                  <td><strong>{client.name}</strong></td>
                  <td>{client.contactPerson || '-'}</td>
                  <td>{client.email || '-'}</td>
                  <td>{client.phone || '-'}</td>
                  <td>
                    <Badge bg="info">{client.Locations?.length || 0}</Badge>
                  </td>
                  <td>
                    <Badge bg="secondary">{client.Users?.length || 0}</Badge>
                  </td>
                  <td>
                    <Badge bg={client.isActive ? 'success' : 'secondary'}>
                      {client.isActive ? 'Ενεργός' : 'Ανενεργός'}
                    </Badge>
                  </td>
                  <td>
                    <div className="d-flex gap-1">
                      <Button 
                        size="sm" 
                        variant="outline-primary"
                        onClick={() => handleShowModal(client)}
                      >
                        <i className="bi bi-pencil"></i>
                      </Button>
                      <Button 
                        size="sm" 
                        variant="outline-danger"
                        onClick={() => handleDelete(client.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>


          {clients.length === 0 && (
            <div className="text-center py-4 text-muted">
              Δεν υπάρχουν clients. Πατήστε "Νέος Client" για να δημιουργήσετε.
            </div>
          )}
        </Card.Body>
      </Card>


      {/* Create/Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {editingClient ? 'Επεξεργασία Client' : 'Νέος Client'}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Όνομα Επιχείρησης *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="π.χ. Εστιατόριο Μακεδονία"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Υπεύθυνος Επικοινωνίας</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="π.χ. Γιώργος Παπαδόπουλος"
                    value={formData.contactPerson}
                    onChange={(e) => setFormData({ ...formData, contactPerson: e.target.value })}
                  />
                </Form.Group>
              </Col>
            </Row>


            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="email@example.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Τηλέφωνο</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="2310123456"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Μέγιστος Αριθμός Συσκευών</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    placeholder="10"
                    value={formData.maxDevices || ''}
                    onChange={(e) => setFormData({ ...formData, maxDevices: parseInt(e.target.value) || 1 })}
                  />
                </Form.Group>
              </Col>
            </Row>


            <Form.Group className="mb-3">
              <Form.Label>Διεύθυνση</Form.Label>
              <Form.Control
                type="text"
                placeholder="Οδός, Αριθμός, ΤΚ, Πόλη"
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              />
            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Πληροφορίες Επιχείρησης</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Προαιρετικές πληροφορίες..."
                value={formData.companyInfo}
                onChange={(e) => setFormData({ ...formData, companyInfo: e.target.value })}
              />
            </Form.Group>


            {!editingClient && (
              <>
                <hr />
                <h6>Στοιχεία Σύνδεσης</h6>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Username *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Username για login"
                        value={formData.username}
                        onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                        required={!editingClient}
                      />
                    </Form.Group>
                  </Col>
                  
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Password *</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Τουλάχιστον 6 χαρακτήρες"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        required={!editingClient}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Ακύρωση
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}


export default Clients;
